import React from 'react';
import DashBoard from '../../containers/DashBoard';

function Home() {
  return <DashBoard />;
}

export default Home;
